import requestHandler from 'shared/utils/request-handler';
import { IReferralBalance } from './referral-balance.dto';

const BASE_URL = '/api/v1/referralBalance';

export const GETReferralBalance = async () => {
	return requestHandler.call<IReferralBalance[]>({ url: `${BASE_URL}`, method: 'get' }).then(res => res.data);
};
